module.exports = __webpack_public_path__ + "static/media/junte-troque-modal.23e6a399.png";